import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { handleGetNotificationList } from './notificationThunk';
import { INotification } from '~/utils/interface/notification';
import { ROWS_PER_PAGE } from '~/utils/constants/common';

interface INotificationFilter {
  page: number;
  limit: number;
}

export interface NotificationState {
  notificationList: Array<INotification>;
  filterList: INotificationFilter;
  needRefreshData: boolean;
}

const initialState: NotificationState = {
  notificationList: [],
  needRefreshData: false,
  filterList: {
    page: 1,
    limit: ROWS_PER_PAGE,
  },
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setFilterList(state, action: PayloadAction<INotificationFilter>) {
      state.filterList = { ...state.filterList, ...action.payload };
    },
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(handleGetNotificationList.fulfilled, (state, action) => {
      if (state.filterList.page === 1) {
        state.notificationList = [...action.payload.responses];
      } else {
        state.notificationList = [...state.notificationList, ...action.payload.responses];
      }
    });
  },
});

export const notificationActions = notificationSlice.actions;

const notificationReducer = notificationSlice.reducer;
export default notificationReducer;
